import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { USER_TYPE_TAG } from "@/shared/tagFile";
import { formateColumnFilter } from "@/utils/columnFilter";
import { successToast } from "@/shared/components/toast";
import UserTypeForm from "./UserTypeForm";
import { getAllUserTypes } from "../../AuthSlice";
import "react-toastify/dist/ReactToastify.css";

const UserType = () => {
  const [userTypeDetails, setUserTypeDetails] = useState();
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteUserType, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getUserTypeRecords,
    {
      data: userTypeList,
      isError: userTypeError,
      isLoading: userTypeLoading,
      isFetching: userTypeFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Name",
      accessor: "Name",
      filter: true,
    },
    {
      Header: "Description",
      accessor: "Description",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleSelectedRecord = (userTypeData) => {
    setSelectedRecord(userTypeData);
    setIsOpenAddModal(true);
  };

  const handleDelete = () => {
    deleteUserType({
      entity: "AuthReference/UserType",
      id: selectedRecord.Id,
      tag: USER_TYPE_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsOpenDeleteModal(!isOpenDeleteModal);
        successToast("User type deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );
    getUserTypeRecords({
      entity: "AuthReference/UserTypes",
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: USER_TYPE_TAG,
    });
    setUserTypeDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !userTypeLoading &&
      !userTypeError &&
      userTypeList &&
      !userTypeFetching
    ) {
      dispatch(getAllUserTypes(userTypeList.value));
      let userTypeData = [...userTypeList.value];
      setUserTypeDetails({
        ...userTypeDetails,
        tableRowsData: userTypeList.value ? userTypeData : [],
        totalData:
          userTypeList && userTypeList["@odata.count"]
            ? userTypeList["@odata.count"]
            : 0,
        onEditClick: (data) => handleSelectedRecord(data),
        onDeleteClick: (data) => {
          setIsOpenDeleteModal(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [userTypeError, userTypeList, userTypeLoading, userTypeFetching]);

  return (
    <Container>
      <Row>
        {userTypeDetails && (
          <DataReactTable
            reactTableData={userTypeDetails}
            onAddClick={() => {
              setIsOpenAddModal(true);
              setSelectedRecord();
            }}
            title="User Type"
            isFetching={userTypeFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isOpenAddModal && (
        <AddModal
          toggle={() => setIsOpenAddModal(!isOpenAddModal)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} User Type`}
          header
          btn="Success"
          message={
            <UserTypeForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsOpenAddModal={setIsOpenAddModal}
            />
          }
        />
      )}
      {isOpenDeleteModal && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsOpenDeleteModal(!isOpenDeleteModal)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default UserType;
